// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuTableCell:has(.vuuIconButtonCell){padding:0;position:relative}.vuuIconButtonCell{--saltButton-height:100%;--saltButton-minWidth:100%;--saltButton-padding:0;--saltButton-width:100%;justify-content:center;align-items:center;height:100%;padding:0;font-weight:500;display:inline-flex;position:relative}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
